// extracted by mini-css-extract-plugin
var _1 = "category-hl__BCwLC";
export { _1 as "category-hl" }
